export const app_version_prefix = 'berd_v'
export const app_version = app_version_prefix + 2611;  //increment this to reset local state when new version is released, so the slate is clean
export const cache_prefix = `${app_version}_csvg`;
